var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Legend'),_c('div',{staticClass:"loading-background",class:{hidden: _vm.loaded}},[_c('div',{staticClass:"flex-child loading",attrs:{"id":"spinner"}})]),_c('div',{staticClass:"map",attrs:{"id":"map"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }